import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { useNavigate } from 'react-router-dom';
import HeroSection from './HeroSection';
import HowItWorksSection from './HowItWorksSection';
import PricingSection from './PricingSection';
import FAQSection from './FAQSection';

const Home = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <HeroSection t={t} navigate={navigate} currentLang={i18n.language} />
      <HowItWorksSection t={t} />
      <PricingSection t={t} navigate={navigate} currentLang={i18n.language} />
      <FAQSection t={t} />
      <Footer />
    </>
  );
};

export default Home;
